var map = {
	"./atualidades-e-negocios/2.jpg": [
		150,
		1
	],
	"./celebridades-e-tv/2.jpg": [
		151,
		4
	],
	"./criancas-e-quadrinhos/2.jpg": [
		152,
		7
	],
	"./decoracao-e-jardinagem/2.jpg": [
		153,
		10
	],
	"./especializadas/2.jpg": [
		154,
		13
	],
	"./esportes/2.jpg": [
		155,
		16
	],
	"./estilo-de-vida-e-moda/2.jpg": [
		156,
		19
	],
	"./games-e-tecnologia/2.jpg": [
		157,
		22
	],
	"./gastronomia-e-receitas/2.jpg": [
		158,
		25
	],
	"./historia-e-educacao/2.jpg": [
		159,
		28
	],
	"./saude-e-bem-estar/2.jpg": [
		160,
		31
	],
	"./viagens-e-lazer/2.jpg": [
		161,
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 95;
module.exports = webpackAsyncContext;